import { render, staticRenderFns } from "./ModalAnswerTemplate.vue?vue&type=template&id=3c4781d1&lang=pug&"
import script from "./ModalAnswerTemplate.vue?vue&type=script&lang=js&"
export * from "./ModalAnswerTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ModalAnswerTemplate.vue?vue&type=style&index=0&id=3c4781d1&prod&lang=sass&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports